import { render } from "./RewardBalance.vue?vue&type=template&id=c978f28a"
import script from "./RewardBalance.vue?vue&type=script&lang=js"
export * from "./RewardBalance.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__